// ============================================================================
// Sub-change reason wording, with no database dependency, so pure display code
// (the tier screens, their tests) can name a reason without loading a client.
// The list itself lives in facility_lifecycle_reasons (kind sub_change); see
// ./sub-change-reasons.tsx. Item #667.
// ============================================================================

/** The line under each choice on the form. Keyed by code; a reason added to the
 *  list later simply shows without one. */
export const SUB_CHANGE_REASON_HELP: Record<string, string> = {
  sub_removed_for_quality: 'Including the client asking for a new team because of the cleaning',
  sub_gave_up_building: 'Rate, workload, left the market, or chose to end the agreement',
  sub_same_crew_new_company: 'The owner handed the business on; the same people keep cleaning',
  sub_record_fix: 'Wrong name on file. To change a rate, use Start a rate change on the building.',
};

/** Short form for chips on lists and the At risk tab. */
const SHORT: Record<string, string> = {
  sub_removed_for_quality: 'Scope not met after written notice',
  sub_gave_up_building: 'Sub gave up building',
  sub_same_crew_new_company: 'Same crew, new company',
  sub_record_fix: 'Record fix',
  sub_reason_not_recorded: 'Reason not recorded',
  sub_other: 'Other (explain in notes)',
};

/**
 * How an ended assignment reads, by reason (item 871, Ben 2026-10-19). A display
 * mapping from the reason code only — no stored field. It replaces "counts as a
 * loss" wording; which reasons count on the tier screens is unchanged
 * (facility_lifecycle_reasons.default_intent).
 */
const OUTCOME: Record<string, string> = {
  sub_removed_for_quality: 'Ended by TCS',
  sub_gave_up_building: 'Ended by subcontractor',
  sub_same_crew_new_company: 'Administrative change',
  sub_record_fix: 'Administrative change',
  sub_other: 'Other (explain in notes)',
  sub_reason_not_recorded: 'Not recorded',
};
export function subChangeOutcome(code: string | null | undefined): string {
  return (code && OUTCOME[code]) || 'Not recorded';
}
export function subChangeReasonShort(
  code: string,
  reasons?: Array<{ reason_code: string; label: string }>,
): string {
  return SHORT[code] ?? reasons?.find((r) => r.reason_code === code)?.label ?? code;
}

